import React from 'react';
import logo from '../assets/images/saude-movel-brasil.png';

const Header = () => {
    return (
        <header>
            <div className="container py-4">
                <div className="row">
                    <div className="col-12 text-center text-lg-start">
                        <a href="/">
                            <img src={logo} className="img img-fluid" alt="Saúde Móvel Brasil" />
                        </a>
                    </div>
                </div>

            </div>
        </header>
    );
};

export default Header;